import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function confirm(secret) {
  const axios = axiosInstance().primoLab;
  let data = {};

  await axios
    .post("/2fa/confirm", {
      secret,
    })
    .then(async (response) => {
      data = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data;
    });

  return { data };
}
